import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum SnackbarMessageType {
  success,
  failure,
}

export interface SnackbarData {
  type: SnackbarMessageType;
  title?: string;
  message: string;
  duration?: number;
}

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  public onNewSnackbar = new Subject<SnackbarData>();

  constructor() {}

  public showSnackbar = (data: SnackbarData) => {
    this.onNewSnackbar.next(data);
  };
}
